var map = {
	"./Domestic-white.svg": 4067,
	"./Domestic.svg": 9283,
	"./avatar.jpg": 8084,
	"./avatar.png": 5536,
	"./background.jpg": 5671,
	"./cauliflower_logo_web.png": 2001,
	"./commercial-white.svg": 8753,
	"./commercial.svg": 3597,
	"./custom-select.png": 1773,
	"./delivery-man-black.svg": 9418,
	"./delivery-man.svg": 2672,
	"./delivery-truck.svg": 9837,
	"./delivery-truk-black.svg": 7440,
	"./error-bg.jpg": 9069,
	"./loder.png": 3527,
	"./login-rectangle.png": 5596,
	"./login.jpg": 7000,
	"./no_logo.png": 9670,
	"./ns.png": 6626,
	"./ns2.png": 5482,
	"./profile.png": 5572,
	"./stock-book-logo.svg": 1169,
	"./stockbook-imacMockup.png": 4558,
	"./whatsapp.svg": 3465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;